"use client";

import React, { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { Button } from "../ui/button";
import { ScrollObserver } from "../scroll-observer";
import { X } from "lucide-react";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <ScrollObserver />
      <header className="px-4 lg:px-6 h-20 flex items-center border-b backdrop-blur-sm bg-white/80 sticky top-0 z-50">
        <div className="container px-4 flex items-center">
          <Link className="flex items-center justify-center" href="/">
            <div className="relative animate-pulse-slow">
              <Image
                src="/logo.png"
                width={50}
                height={40}
                alt="TinyERP Logo"
                className="rounded-lg"
              />
            </div>
            <span className="ml-2 text-xl font-bold bg-gradient-to-r from-indigo-500 to-purple-500 bg-clip-text text-transparent">
              TinyERP
            </span>
          </Link>
          <nav className="ml-auto hidden md:flex gap-4 sm:gap-6">
            <Link
              className=" font-medium hover:text-primary transition-colors relative group"
              href="/about-us"
            >
              Sứ mệnh
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link
              className=" font-medium hover:text-primary transition-colors relative group"
              href="/solutions"
            >
              Giải pháp
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link
              className=" font-medium hover:text-primary transition-colors relative group"
              href="/pricing"
            >
              Bảng giá
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link
              className=" font-medium hover:text-primary transition-colors relative group"
              href="/#customer"
            >
              Khách hàng
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link
              className=" font-medium hover:text-primary transition-colors relative group"
              href="/#blog"
            >
              Blog
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link
              className=" font-medium hover:text-primary transition-colors relative group"
              href="/contact"
            >
              Liên hệ
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
            </Link>
          </nav>
          <div className="hidden md:flex items-center ml-4 lg:ml-6">
            <Button
              variant="outline"
              size="sm"
              className="mr-2 border-indigo-200 hover:bg-indigo-50 hover:text-indigo-600  font-medium transition-all"
            >
              Đăng nhập
            </Button>
            <Button
              size="sm"
              className="bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 text-white font-medium  transition-all"
            >
              Dùng thử miễn phí
            </Button>
          </div>
        </div>

        {/* Mobile Menu Toggle */}
        <div className="md:hidden ml-auto flex items-center">
          <Button
            variant="ghost"
            size="icon"
            className="text-gray-700 hover:bg-indigo-50"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <svg
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </Button>
        </div>
      </header>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden fixed inset-x-0 top-20 z-50 bg-white border-b border-gray-200 shadow-lg animate-fade-in">
          <div className="px-4 py-4 space-y-3">
            <Link
              href="/about-us"
              className="block py-2.5 px-4 rounded-lg text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Sứ mệnh
            </Link>
            <Link
              href="/solutions"
              className="block py-2.5 px-4 rounded-lg text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Giải pháp
            </Link>
            <Link
              href="/pricing"
              className="block py-2.5 px-4 rounded-lg text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Bảng giá
            </Link>
            <Link
              href="/#customer"
              className="block py-2.5 px-4 rounded-lg text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Khách hàng
            </Link>
            <Link
              href="/#blog"
              className="block py-2.5 px-4 rounded-lg text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Blog
            </Link>
            <Link
              href="/contact"
              className="block py-2.5 px-4 rounded-lg text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Liên hệ
            </Link>
            <div className="pt-2 flex flex-col space-y-2">
              <Button
                variant="outline"
                className="w-full justify-center border-indigo-200 hover:bg-indigo-50 hover:text-indigo-600"
              >
                Đăng nhập
              </Button>
              <Button className="w-full justify-center bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 text-white">
                Dùng thử miễn phí
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
